import { render, staticRenderFns } from "./DonationReason.vue?vue&type=template&id=bf217f66&scoped=true"
import script from "./DonationReason.vue?vue&type=script&lang=js"
export * from "./DonationReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf217f66",
  null
  
)

export default component.exports